<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="filters.owner.id" :options="owners" clearable placeholder="placeholder.owner" style="width: 15%" @change="refresh"/>
        <vxe-input v-model="filters.item.no" clearable placeholder="placeholder.itemNo" style="width: 10%" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="filters.lot.no" clearable placeholder="placeholder.lotNo" style="width: 10%" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="filters.storageRoom.name" clearable placeholder="placeholder.storageRoom" style="width: 10%" @clear="onStorageRoomClear" @dblclick.native="onStorageRoomSelect"/>
        <vxe-input v-model="filters.zone.name" clearable placeholder="placeholder.zone" style="width: 10%" @clear="onZoneClear" @dblclick.native="onZoneSelect"/>
        <vxe-input v-model="filters.location.no" clearable placeholder="placeholder.location" style="width: 10%" @clear="onLocationClear" @dblclick.native="onLocationSelect"/>
        <vxe-input v-model="filters.container.no" clearable placeholder="placeholder.containerNo" style="width: 10%" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="dateRange" clearable linked-panels placeholder="business.label.date" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table ref="table" :data="data" :export-config="{}" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="balance.balanceDate" title="business.label.date" width="90"/>
        <vxe-column field="owner.name" title="business.label.owner" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="150"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="lot.no" title="business.label.lotNo" width="120"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="90"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="90"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="80"/>
        <vxe-column field="lot.producingArea" title="business.label.producingArea" width="80"/>
        <vxe-column field="location.no" title="business.label.location" width="130"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="100"/>
        <vxe-column field="zone.name" title="business.label.zone" width="100"/>
        <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:inventoryStates}" field="balance.inventoryState" title="business.label.inventoryState" width="80"/>
        <vxe-column field="balance.quantity" title="business.label.quantity" width="80"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <zone-modal ref="zoneModal" @change="onZoneChange"/>
    <location-modal ref="locationModal" @change="onLocationChange"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import { InventoryFactoryView } from '@/api/dto/view/InventoryFactoryView'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Zone } from '@/api/dto/common/Zone'
import { Location } from '@/api/dto/common/Location'
import moment from 'moment'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'BalanceQuery',
  components: { LocationModal, StorageRoomModal, ZoneModal },
  data() {
    return {
      loading: false,
      filters: new InventoryFactoryView(),
      dateRange: [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
      data: [],
      owners: [],
      inventoryStates: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('InventoryState')
    }).then(result => {
      this.inventoryStates = result
    }).finally(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, physical: true })
    },
    onStorageRoomChange(value) {
      this.filters.storageRoom = new StorageRoom(value[0])
      this.refresh()
    },
    onStorageRoomClear() {
      this.filters.storageRoom = new StorageRoom()
      this.refresh()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.id': this.filters.storageRoom.id })
    },
    onZoneChange(value) {
      this.filters.zone = new Zone(value[0])
      this.refresh()
    },
    onZoneClear() {
      this.filters.zone = new Zone()
      this.refresh()
    },
    onLocationSelect() {
      this.$refs.locationModal.open({ 'storageRoom.id': this.filters.storageRoom.id, 'zone.id': this.filters.zone.id })
    },
    onLocationChange(value) {
      this.filters.location = new Location(value[0])
      this.refresh()
    },
    onLocationClear() {
      this.filters.location = new Location()
      this.refresh()
    },
    refresh() {
      this.loading = true
      const args = {
        'owner.id': this.filters.owner.id,
        'item.no': this.filters.item.no,
        'lot.no': this.filters.lot.no,
        'location.id': this.filters.location.id,
        'location.no': this.filters.location.no,
        'zone.id': this.filters.zone.id,
        'zone.name': this.filters.zone.name,
        'storageRoom.id': this.filters.storageRoom.id,
        'storageRoom.name': this.filters.storageRoom.name,
        'container.no': this.filters.container.no,
        dateFilter: { start: this.dateRange[0], end: this.dateRange[1] }
      }
      findAll('balanceFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.filters = new InventoryFactoryView()
      this.dateRange = [moment().subtract(1, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')]
      this.data = []
      this.page = 1
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>